<template>
    <div class="container-fluid">
        <nav aria-label="breadcrumb" class="col-sm-12">
            <ol class="breadcrumb bg-orange mb-0">
                <li class="breadcrumb-item"><a href="#" class="text-white"><i class="ri-home-4-line mr-1 float-left"  style="font-size: 20px;"></i>Slot</a></li>
                <li class="breadcrumb-item active text-white" aria-current="page">Slot Roadmap</li>
            </ol>
        </nav>    
        <br>
        <div class="container-fluid" style="display: flex">
        <div class="roadmap col-lg-9" >
            <div style="padding-top: 30px; padding-bottom: 30px">
                <b-row>
                    <b-col sm="6">
                        <h4 class="mt-10 mb-2">Roadmap</h4>
                    </b-col>
                    <b-col sm="6" class="export">
                        <el-button class="float-right" style="background: #f26a0c" type="warning" icon="el-icon-document" @click="handleDownload">
                            <span class="text-white">Export Excel</span>
                            
                        </el-button>            
                    </b-col>
                    <br>
                </b-row>  
            </div>

            <el-table :data="list" border fit highlight-current-row style="background-colour: transparent">
                <el-table-column align="center">
                    <template slot-scope="scope" >
                        <h6 class="text-center text-primary" v-if="Date.now() < new Date(scope.row.releaseDate)">Coming Soon</h6>
                        <div class="justify-content-center" v-else>
                            <img :src="getImgUrl(scope.row.code)" class="img-fluid img-thumbnail" width="55%">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Name" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Available for Testing"  align="center">
                    <template slot-scope="scope">
                        <div class="justify-content-center button" align="center" v-if="Date.now() > new Date(scope.row.releaseDate)">
                            <b-button style="font-size: 14px;" pill variant="orange" v-bind:href="'https://play.nextspin.com/games/game.php?game='+scope.row.code+'&language=en_US'" target="_blank" class="mt-2 mr-1 text-white" >Play Demo Game</b-button>
                        </div> 
                        <div class="justify-content-center" v-else>{{scope.row.releaseDate | replace('-','/')}}</div> 
                    </template>
                </el-table-column>
                <el-table-column label="Release Date" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.releaseDate | replace('-','/') }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="roadmap-sidebar col-sm-3">
            <div class="calendar">
                <v-calendar
                    :attributes='attributes'
                    @dayclick='dayClicked'>
                </v-calendar>
                <ul id="example-1">
                    <li v-for="item in events" v-bind:key="item.id">
                        {{item.desc}}
                    </li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</template>
<style>
    .export-btn {
        width: 20%; 
        display: inline-block
    }
    .container {
        display: flex;
    }
    .roadmap-sidebar {
        display: flex;
        padding-top: 20px;
    }
    .content-page {
        padding: 80px 15px 0px;  
    }
    .el-table{
        background: transparent
    }
    .calendar{
         background: transparent
    }

</style>
<script lang="javascript" src="dist/xlsx.full.min.js"></script>
<script src='https://unpkg.com/vue/dist/vue.js'></script>
<script src='https://unpkg.com/v-calendar'></script>

<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import XLSX from 'xlsx'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import VCalendar from 'v-calendar';

const URL = require("../../../../config");
Vue.use(VueAxios, axios, moment, XLSX)
Vue.use(ElementUI)
Vue.use(DataTablesServer)
Vue.use(VCalendar)

export default {
    name:'SlotRoadmap',
    data() {
        return {
            list: [],
            upcoming:[],
            calendar:[],
            name:'',
            listLoading: true,
            downloadLoading: false,
            filename: 'NextSpin Slot Roadmap',
            autoWidth: true,
            bookType: 'xlsx',           
            events : [],
            selectedDay: new Date()
            
        }
    },
    async mounted() {
        let response = await Vue.axios.get( URL.api.URL + '/api/slots/roadmap', { params: { m: this.$route.meta.uid } });
        this.list = response.data.slot_games

        var currentDate = new Date();
        this.list.forEach(element => {
            var releaseDate = element.releaseDate;
            var code = element.code;
            var dates = releaseDate.split("-").join('/').split('/').join(',')
            var formatted_dates = (new Date (dates))

            var to_do = {
                date :   formatted_dates, 
                desc : element.name + " is available"
            }

            this.calendar.push(to_do)
    
            if(moment(releaseDate).isAfter(moment(currentDate).format("YYYY/MM/DD"))) {
               this.upcoming.push(code)
            }
            else {
              return false 
            }              
        });
        this.getEvent()
       
    },

    filters: {
        replace: function (st, rep, repWith) {
        const result = st.split(rep).join(repWith)
        return result;
        }
    },

    methods:{
        ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet JS"});
        return dl ?
        XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
        XLSX.writeFile(wb, fn || (('NextSpin SLOT Roadmap.') + (type || 'xlsx')));
    },

    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['Name', 'Available for Testing', 'Release Date']
        const filterVal = ['name', 'releaseDate','releaseDate']
        const list = this.list
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },

    dayClicked(day) {
      this.selectedDay = day.date;
      this.getEvent()
    },

    getEvent(){
        this.events = []
        this.calendar.forEach(element => {
            var x = moment(element.date)
            var selected = moment(this.selectedDay)
            if (x.isSame(selected) ){
                this.events.push(element)
            }           
        });
    } ,
    getImgUrl(gamecode) {
            try {
                return require('../../../../static/images/gamepic/'+gamecode+'_350x350.jpg');
            } catch (error) {
               return require('../../../assets/images/NS_Black_cleaned.svg');
            }
        }  
  },

  computed: {
      attributes() {
      return this.calendar.map(t => ({
            dot:true,
            dot: 'orange',
            dates: t.date,
            popover: {
            label: t.desc,
          },
          customData: t,
      }));
    },
  }
}
</script>